import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import TransferCertificate from './TransferCertificate';
import config from '../../../config';
import axios from '../../../interceptor/axios-config';

const PrintModal = ({ show, onClose, tcPrintData }) => {
  const componentRef = useRef();

   // End-point for TC-Print record
   const RECORD_TC_PRINT =`${config.apiBaseUrl}/tc/recordPrint.php`;

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => {
      // Perform the Axios PATCH request after printing
      axios.patch(RECORD_TC_PRINT, {
        tc_id: tcPrintData.tc_id
      })
      .then(response => {
        console.log('Print record updated:', response.data);
        onClose(); // Close the modal after the request
      })
      .catch(error => {
        console.error('Error updating print record:', error);
        onClose(); // Close the modal even if there was an error
      });
    },
  });

  if (!show) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999, // Highest z-index
      backdropFilter: 'blur(10px)' // Blur effect
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        width: '80%', // Large modal
        height: '100%', // Large modal
        boxSizing: 'border-box',
        overflow: 'auto',
        position: 'relative'
      }}>
        {/* <h2 style={{ textAlign: 'center' }}>Print Transfer Certificate</h2> */}
        <div className='d-flex justify-content-center'>          
          <button className='btn btn-danger' onClick={onClose} style={{ marginRight: '10px' }}>Close</button>
          <button className='btn btn-success' onClick={handlePrint}>Print</button>
        </div>
        <TransferCertificate ref={componentRef} {...tcPrintData} />
        <div style={{
          marginTop: '20px',
          textAlign: 'right',
          position: 'absolute',
          bottom: '10px',
          right: '10px'
        }}>
        </div>
      </div>
    </div>
  );
};

export default PrintModal;
